/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ contactType: NonNullable<unknown> }} Client_Contact_Type_LabelInputs */

const en_client_contact_type_label = /** @type {(inputs: Client_Contact_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.contactType === "managerial") return /** @type {LocalizedString} */ (`Managerial`);
	if (i?.contactType === "legal") return /** @type {LocalizedString} */ (`Legal`);
	if (i?.contactType === "administrative") return /** @type {LocalizedString} */ (`Administrative`);
	return /** @type {LocalizedString} */ (`${i?.contactType}`)
	
};

const pt_br2_client_contact_type_label = /** @type {(inputs: Client_Contact_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.contactType === "managerial") return /** @type {LocalizedString} */ (`Gerencial`);
	if (i?.contactType === "legal") return /** @type {LocalizedString} */ (`Jurídico`);
	if (i?.contactType === "administrative") return /** @type {LocalizedString} */ (`Administrativo`);
	return /** @type {LocalizedString} */ (`${i?.contactType}`)
	
};

/**
* | contactType | output |
* | --- | --- |
* | "managerial" | "Managerial" |
* | "legal" | "Legal" |
* | "administrative" | "Administrative" |
* | * | "{contactType}" |
*
* @param {Client_Contact_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_contact_type_label = /** @type {((inputs: Client_Contact_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Contact_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_contact_type_label(inputs)
	return pt_br2_client_contact_type_label(inputs)
});